import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { ChronoIcon } from "@images/svgIcons/chronoIcon"
import { BenchmarkEntity } from "@modules/benchmark/entities/benchmarkEntity"
import { displayTotalTime, getTrainingChronoTitle } from "@modules/chrono/chronoUtils"
import { word } from "@modules/core/utils/i18n"
import { HURichTextView } from "@modules/ui/components/richText/huRichTextView"
import { formatTextToRichText } from "@modules/ui/components/richText/richTextUtils"
import { CheckIcon } from "lucide-react"

type BenchmarkExerciseProps = {
  benchmark: BenchmarkEntity
} & React.ComponentProps<"div">

export function BenchmarkExercise({ benchmark, className, ...props }: BenchmarkExerciseProps) {
  return (
    <div className={cn("my-2.5 flex flex-col rounded-4xl bg-secondary-800 p-2 pt-4", className)} {...props}>
      <div className="flex items-center p-2.5 pt-0">
        <div className="rounded-full bg-neutral-400 p-1 ring-2 ring-primary-700">
          <CheckIcon className="size-4 text-neutral-500" />
        </div>

        <Text fontStyle="TS" className="ml-2 text-white">
          {word("exercise.category.wod.name")}
        </Text>
      </div>

      <div className="flex flex-col rounded-3xl bg-white p-5 pt-7">
        <div className="mb-4 flex items-center">
          <div className="flex flex-row items-center gap-1">
            <ChronoIcon color="currentColor" className="text-neutral-900" width={15} height={15} />
            <Text fontStyle="LL" className="text-neutral-900">
              {benchmark.chrono?.type
                ? getTrainingChronoTitle(benchmark.chrono.type) + " - " + displayTotalTime(benchmark.chrono)
                : word("chrono.title.no_chrono")}
            </Text>
          </div>
        </div>

        <HURichTextView value={formatTextToRichText(benchmark.description)} paragrapheFontStyle="BM" />
      </div>
    </div>
  )
}
